import { render, staticRenderFns } from "./PayWall.vue?vue&type=template&id=442d4d3c&"
import script from "./PayWall.vue?vue&type=script&lang=js&"
export * from "./PayWall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports